import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div\n  class=\'position-absolute top-0 left-0 right-0 bottom-0 bg-color-grey-3 opacity-30\'\n>\n  {{yield}}\n</div>")